import { call, put, select } from 'redux-saga/effects';
import { eventBus } from 'utils/eventBus';
import { raiseHandNotificationUpdateRequested } from 'features/notifications/actions';
import { signalingPhoneUserHandRaised } from 'features/sip/actions';
import { TelephonyUser } from 'features/sip/types';
import { selectPhoneUserById } from 'features/sip/sipSlice';

export function* onPhoneUserHandRaisedSaga(
  action: ReturnType<typeof signalingPhoneUserHandRaised>
) {
  const { initiator } = action.payload;
  if (!initiator) {
    return;
  }

  const { id: initiatorId } = initiator;

  yield call(eventBus.sendMessage, 'handRaised', { userId: initiatorId });

  const initiatorUser: TelephonyUser | undefined = yield select(selectPhoneUserById, initiatorId);
  if (!initiatorUser) {
    return;
  }

  yield put(raiseHandNotificationUpdateRequested({ reason: 'hand-raised' }));
}
